import React from "react";
import { Link } from "react-router-dom";
import { recommendedItems, recTitlesAr } from "../../content/homeMarketing";
import "../Home.css";

const HIDDEN_REC_SLUGS = new Set([
  "tattoo-&-piercing-shops",
  "makeup-&-brows-&-lashes",
]);

export default function RecommendedGrid({ t, lang }) {
  const visibleItems = recommendedItems.filter((item) => !HIDDEN_REC_SLUGS.has(item.slug));

  return (
      <section className="recommended recommended--grid container scroll-animate from-bottom" id="recommended-tips" aria-labelledby="rec-title">
      <div className="recommended-header">
        <div>
          <h2 id="rec-title" className="home-section-title scroll-animate from-bottom delay-1">
            {t.recTitle}
          </h2>
          {t.recSubtitle && (
            <p className="recommended-subtitle scroll-animate from-bottom delay-1">{t.recSubtitle}</p>
          )}
        </div>
      </div>
      <div className="recommended-grid scroll-animate from-bottom delay-2">
        {visibleItems.map((item) => {
          const title = lang === "ar" ? recTitlesAr[item.slug] || item.title : item.title;
          return (
            <Link key={item.slug} to={`/rec/${item.slug}`} className="recommended-item recommended-item--grid">
              <figure className="recommended-card">
                <img src={item.image} alt={title} className="recommended-image" loading="lazy" />
                <figcaption className="recommended-title">{title}</figcaption>
              </figure>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
